export default "__VITE_ASSET__39738163__"